import { FS_CLASSES } from '@calendly/ui/components/fullstory-privacy';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { ReactNode } from 'react';
const appShellIsPhoneCss = "a4q4dsn";

/** Desktop: nav + app bar + body row (content + optional side panel). */
const appShellCss = "a12o72l8";
interface AppShellProps {
  children: ReactNode;
}

/**
 * Product-refresh shell: viewport-sized grid; page scroll lives inside `CenterPanelContent`.
 * The body row (content + optional side panel) is a flex row managed by `AppLayout`.
 */
export const AppShell = ({
  children
}: AppShellProps) => {
  const isPhone = useDeviceType('isPhone');
  return <div id="app-shell" className={classNames(appShellCss, FS_CLASSES.UNMASK, {
    [appShellIsPhoneCss]: isPhone
  })}>
      {children}
    </div>;
};

require("./AppShell.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AppShell.tsx");